export const userAccountApp = {
  "AccountSettings.MyDetails.MyDetails.updateDetailsButton":
    "update-details-button",
  "AccountSettings.FormSection.Form": "form",
  "AccountSettings.SettingSection.primaryButton": "primary-button",
  "AccountSettings.SettingSection.secondaryButton": "secondary-button",
  "LabelValueRow.LabelValueRow": "-value",
  "MySubscription.BuyAddOn.button": "buy-addon-button",
  "Pagewrapper.Footer.closeButton": "close-button",
  "MySubscription.SubscriptionType.value": "Subscription Type",
  "MySubscription.CurrentPeriod.value": "Current Period",
  "MySubscription.ExpiresOn.value": "Renews/Expires on",
  "MySubscription.AdditionalServices.value": "Additional services",
  "MyAccountPage.QuickLinks.header": "quick-links-header",
  "MyAccountPage.QuickLinks.link": "quick-links",
  "MyAccountPage.NotificationBanner.button": "notification-button",
  "Component.SectionBox.Title": "section-title",
  "Component.SectionBox.Description": "section-description",
  "Component.SectionBox.Card": "card-div",
  "MySubscription.Section.subscriptionData": "subscription-data",
  "MySubscriptionPage.AdditionalService.FilmmakerPremium":
    "filmmaker-premium-section",
  "MySubscriptionPage.SubscriptionData.subscriptionDueDate":
    "subscription-duration-section",
  "MySubscriptionPage.SubscriptionData.subscriptionType":
    "subscription-type-section",
};
